import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { DraftPurchaseOrderSubmission } from '@erp/rpc';

export type { DraftPurchaseOrderSubmission };

/** How a new PO from this vendor to this branch would be sent. */
export function useSubmissionDefaults(
  scope: { supplierId: string; warehouseId: string } | null,
) {
  return useQuery({
    ...orpc.procurement.purchaseOrderSubmission.defaults.queryOptions({
      input: scope ?? { supplierId: '', warehouseId: '' },
    }),
    enabled: scope !== null,
  });
}

export function useDraftSubmission(draftPurchaseOrderId: string | null) {
  return useQuery({
    ...orpc.procurement.purchaseOrderSubmission.get.queryOptions({
      input: { draftPurchaseOrderId: draftPurchaseOrderId ?? '' },
    }),
    enabled: Boolean(draftPurchaseOrderId),
  });
}

export function useSetDraftSubmission() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.procurement.purchaseOrderSubmission.set.mutationOptions({
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: orpc.procurement.purchaseOrderSubmission.key(),
        }),
    }),
  );
}
